import EditIcon from "@material-ui/icons/Edit";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PropTypes from "prop-types";
import React, { useMemo, useCallback, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Scrollbars } from "react-custom-scrollbars";
import { useHistory } from "react-router-dom";
import constant from "../../../util/constant";
import { eventTypesTableConfigs, eventTypesPartnerTableConfigs } from "../../../util/tableConstant";
import { ScrollPage } from "../customScrollBar";
import TableHeaderRow from "../tableHeadingRow";

const { ROUTES } = constant;

const EventTypes = ( { onSorting, eventTypes, onScroll, eventTypeEditUrl, role, showFilter } ) => {
  const ref = useRef( null );
  const history = useHistory();
  const memoizedTableConfig = useMemo( () => {
    return role === "partner" ? eventTypesTableConfigs : eventTypesPartnerTableConfigs;
  }, [] );

  const memoizedHandleClick = useCallback(
    ( sortBy, orderType ) => onSorting( sortBy, orderType ),
    []
  );

  const eventTypeOperation = ( eventType ) => {
    return (
      <>
        <Dropdown.Item onClick={() => history.push(
          eventTypeEditUrl.replace( ":eventTypeId", eventType.eventTypeId )
        )}>
          <span className='rounded'>
            <EditIcon />
          </span>
          <span>Edit</span>
        </Dropdown.Item>
      </>
    );
  };

  return (
    <>
      <div className='table-container event-partner-table'>
        <div className='table-head'>
          <div className='table-row'>
            <TableHeaderRow
              configData={memoizedTableConfig}
              onAscOrder={memoizedHandleClick}
              onDescOrder={memoizedHandleClick}
            />
          </div>
        </div>
        <Scrollbars renderThumbVertical={ScrollPage}
          className={`custom-scroll-height ${ !showFilter ? "" : "full-height" }`}
          onScroll={onScroll}
        >
          <div className='table-body no-scrollbar' >
            {Boolean( eventTypes.length ) && eventTypes.map( ( eventType, index ) => (
              <div className='table-row' key={index}>
                <div className='td'>{eventType.eventTypeId}</div>
                <div className='td'>
                  <span className="strong line-ellipses">{eventType.eventName}</span>
                </div>
                <div className='td'>{eventType.unitName}</div>

                <div className='td'>{eventType.partnerName ? eventType.partnerName : "QX" }</div>

                <div className='td' ref={ref}>
                  <OverlayTrigger container={ref}
                    placement='auto'
                    overlay={<Tooltip className="event-tooltip">{eventType.description}</Tooltip>}
                  >
                    <span className='line-ellipses'>{eventType.description}</span>
                  </OverlayTrigger>
                </div>

                <div className='td'>{eventType.isActive ? "Enabled" : "Disabled"}</div>
                <div className='td'>
                  <Dropdown className='custom-dropdown more-dropdown'>
                    <Dropdown.Toggle variant='success' id='' className='m-0'>
                      <MoreVertIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {role === "partner" && ( <Dropdown.Item > <span onClick={() => history.push(
                        ROUTES.PARTNER_EVENT_TYPE_DETAIL.replace( ":eventTypeId", eventType.eventTypeId )
                      )}><VisibilityIcon />View</span></Dropdown.Item> )}

                      {role === "admin" && ( <Dropdown.Item ><span onClick={() => history.push(
                        ROUTES.ADMIN_EVENT_TYPE_DETAIL.replace( ":eventTypeId", eventType.eventTypeId )
                      )}><VisibilityIcon />View</span></Dropdown.Item> )}

                      {( role === "partner" ) && ( <div className={ ( ( eventType.isAdmin ) || ( !eventType.isActive ) ) ? "disabled" : ""}>
                        { eventTypeOperation( eventType ) }
                      </div>
                      ) }
                      {role === "admin" && ( <div className={ ( ( !eventType.isAdmin ) || ( !eventType.isActive ) ) ? "disabled" : ""}>

                        { eventTypeOperation( eventType ) }
                      </div> )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            ) )}
            {!eventTypes.length && (
              <div className='no-record' data-testid='no-record-found'>
                  No Event Type Found
              </div>
            )}
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

EventTypes.propTypes = {
  onSorting: PropTypes.func,
  eventTypes: PropTypes.array,
  onScroll: PropTypes.func,
  eventTypeEditUrl: PropTypes.string,
  role: PropTypes.string,
  showFilter: PropTypes.bool,
};

export default EventTypes;
